<template>
  <div id="hello">
    <div class="swiper-container gallery-top swiper-container-horizontal">
      <div class="swiper-wrapper">
        <div v-for="(item,i) in lbt" class="swiper-slide" :style="{backgroundImage: 'url(' + lbt[i].image_url + ')'}"></div>
      </div>
      <!-- Add Pagination -->

    </div>
    <div class="swiper-pagination"></div>
    <section class="hs-box">
      <p class="introduction">核心功能<br/><label>the core function</label></p>
      <ul class="box1-uls">
        <li>
          <div class="ul-div">
            <p class="ul-p" style="background: rgb(10, 202, 177);">
              <img src='../../site/1-14.png' class="boxImg">
            </p> <span class="title1" style="color: rgb(10, 202, 177);">糖尿病诊所</span>
            <span class="content1" style="color: rgb(10, 202, 177);">国内首个1型糖尿病<br/>专科诊所依据并遵从“循证”<br/>的医学诊疗方法患者提供国<br/>际标准的医疗服务</span>
          </div>
        </li>
        <li>
          <div class="ul-div">
            <p class="ul-p" style="background: rgb(241, 158, 194);">
              <img src='../../site/1-11.png' class="boxImg">
            </p>
            <span class="title1" style="color: rgb(241, 158, 194);">线上患教服务</span>
            <span class="content1" style="color: rgb(241, 158, 194);">便捷的线上随访医院<br>已成功帮助上千糖友完成线上患教工作<br>医生+患教师教你进阶血糖教育<br>把“神秘”控糖技能告诉你</span>
          </div>
        </li>
        <li>
          <div class="ul-div">
            <p class="ul-p" style="background: rgb(247, 202, 81);"><img src='../../site/1-12.png' class="boxImg"></p>
            <span class="title1" style="color: rgb(247, 202, 81);">同伴互助控糖</span>
            <span class="content1" style="color: rgb(247, 202, 81);">分享并互评每天的血糖<br>学习控糖乐此不疲，温暧有爱<br>这是1型糖友最温暖的“朋友圈”</span>
          </div>
        </li>
        
      </ul>
    </section>
    <section class="hs-box-s">
      <p class="introduction">其它功能<br/><label>the other features</label></p>
      <p class="hsBoxLi3"></p>
      <p class="hsBoxLiTitle">血糖日历</p>
      <p class="hsBoxLiText">回顾过去每月控糖成绩单<br />在进步中成长帮助90%<br />的糖友有效降低糖化血红蛋白<br />糖友的潜能大大滴</p>
      <p class="hsBoxLi4"></p>
      <p class="hsBoxLiTitle">同城糖友聚会</p>
      <p class="hsBoxLiText">无论您在中国哪个角落总会有一<br />场离您家最近的糖友聚会<br />让同城的糖友从APP走到线下<br />从此同城控糖再也不孤单</p>
      <p class="hsBoxLi5"></p>
      <p class="hsBoxLiTitle">音频漫画视频专题</p>
      <p class="hsBoxLiText">琳琅满目的学习方式充满<br />情感的糖友故事/科普内容<br />多姿多彩的漫画、视频<br />满足不同糖友的需求</p>
      <p class="hsBoxLi6"></p>
      <p class="hsBoxLiTitle">游戏学知识</p>
      <p class="hsBoxLiText">控糖知识也能过关闯将？<br />还能与同伴试比高？<br /> 更能获取奖励？<br />没错，控糖不再枯燥。</p>
      <p class="hsBoxLi7"></p>
      <p class="hsBoxLiTitle">自我管理</p>
      <p class="hsBoxLiText">细分年龄段血糖控制目标和不<br/>同治疗方案，内置血糖<br/>场景智能提示，教你<br/>听身体的声音，做自己的医生</p>
      <p class="hsBoxLi8"></p>
      <p class="hsBoxLiTitle">卫教随访</p>
      <p class="hsBoxLiText">院外随访，数据跟踪，精确<br/>问卷，复诊报告，<br/>医疗卫教人员提高<br/>患者依从性的好帮手！</p>

    </section>
    <section class="hs-box">
      <p style="display:none" v-for="(item, index) in numList.title">
        <span class="numTitle">{{item}}</span>
        <span class="numNum">
          <label :class="'numListTu'+index+''" v-for="(ite, i) in numList.num[index]">{{ite}}</label> 条
        </span>
        <span class="numTime">当天时间{{numList.time}}  累计血糖数据</span>
      </p>
      <div class="diTu"><span><label>中国1型糖尿病患者分布</label><br>截止至2017年12月12日&emsp;</span></div>
    </section>
    <div class="huiSe1">
    <section class="hs-box">
      <p class="hs-app">糖糖圈手机客户端</p>
      <p class="hs-appText">
        国内的1型糖友互助<br/>
        交流平台，有了它，糖友不再无助、<br/>
        不再孤独迷茫！你也加入吧...<br/>
      </p>
      <p class="hs-appTu"></p>
      <a class="box6-14" href="http://a.app.qq.com/o/simple.jsp?pkgname=so.ttq">糖糖圈下载</a>
    </section>
    </div>
    <section class="hs-box-s">
      <p class="introduction">公司动态<br/><label>company dynamics</label></p>
      <a v-for="(item,i) in companyNews" target="_blank" :href='""+host+"/site/detail.html?id="+companyNews[i].id+""'>
        <p class="hsDynamicLi">
          <img class="hsDynamicTu" :src='""+host+"" + companyNews[i].title_img+""'></img>
          <span class="hsDynamicLiText">
            <label class="hsDynamicTop">{{companyNews[i].title}}</label>
            <label class="hsDynamicBottom">{{companyNews[i].summary}}</label>
          </span>
        </p>
      </a>
    </section>
    <section class="hs-box">
      <p class="introduction">合作伙伴<br/><label>cooperative partner</label></p>
      <ul class="box61">
        <li :style='"background: url("+host+"/html/dist/site/6-1.png) no-repeat center center;"' class="box61HsTu"></li>
        <li :style='"background: url("+host+"/html/dist/site/6-3.png) no-repeat center center;"' class="box62HsTu"></li>
        <li :style='"background: url("+host+"/html/dist/site/6-4.png) no-repeat center center;"' class="box61HsTu"></li>
        <li :style='"background: url("+host+"/html/dist/site/6-7.png) no-repeat center center;"' class="box62HsTu"></li>
        <li :style='"background: url("+host+"/html/dist/site/6-6.png) no-repeat center center;"' class="box61HsTu"></li>
        <li :style='"background: url("+host+"/html/dist/site/6-11.png) no-repeat center center;"' class="box62HsTu"></li>
        <li :style='"background: url("+host+"/html/dist/site/6-2.png) no-repeat center center;"' class="box61HsTu"></li>
        <li :style='"background: url("+host+"/html/dist/site/6-9.png) no-repeat center center;"' class="box62HsTu"></li>
        <li :style='"background: url("+host+"/html/dist/site/6-5.png) no-repeat center center;"' class="box61HsTu"></li>
        <li :style='"background: url("+host+"/html/dist/site/6-8.png) no-repeat center center;"' class="box62HsTu"></li>
        <li :style='"background: url("+host+"/html/dist/site/6-10.png) no-repeat center center;"' class="box61HsTu"></li>

      </ul>
    </section>
    <section class="hs-box-s">
      <p class="hs-logo2"></p>
      <p class="hs-end">
        爱宝惟生物科技有限公司版权所有
        <span style="font-size: 14px;margin-top: 15px">Copyright @ 2014-2024 aibaowei.All Rights Reserved<br/><a href="http://www.beian.miit.gov.cn">粤ICP备14072944号</a></span>
      </p>
    </section>
  </div>
</template>

<script>
  import Swiper from '../../site/swiper.min.js'//引入Swiper插件
  let wind_width = parseInt(window.screen.width);
  let mobile_wi = wind_width/750;
  let isAndroid = RegExp("Android").test(navigator.userAgent);
  if(isAndroid) {
    document.write('<meta name="viewport" content="width=750, minimum-scale = '+mobile_wi+', maximum-scale = '+mobile_wi+', target-densitydpi=device-dpi">');
  }else{
    document.write('<meta name="viewport" content="width=750, user-scalable=no, target-densitydpi=device-dpi">');
  }
  let num1=""
  let num2=""
  let num3=""
  export default {
  name: 'hello',
  data () {
    return {
    	host:this.GLOBAL.host,
      lbt: [],
      numList:{
        title:['糖糖圈实时累计血糖数','糖糖圈控糖互助贴子','糖糖圈甜蜜讲堂累计收听量'],
        num:{0:[],1:[],2:[]},
        time:'',
        color:['#f19ec2','#f7ca51','#0acab1']
      },
      companyNews:{}
    }
  },
  methods: {
    getImg (){
      this.$http.get(this.host+'/site/index.html').then((response) => {
        this.lbt=response.data.data.Carousel_Figure;
        setTimeout(function(){
          let swiper = new Swiper('.swiper-container', {
            pagination: {
              el: '.swiper-pagination',
            },
            loop : true,
            autoplay:true,
            autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: false,
            },
          });
        },100);
        num1=""+response.data.data.Statistic_Data.bg_count+"";
        this.numList.num[0]=num1.replace(/(.)(?=[^$])/g,"$1,").split(",");
        num2=""+response.data.data.Statistic_Data.share_count+"";
        this.numList.num[1]=num2.replace(/(.)(?=[^$])/g,"$1,").split(",");
        num3=""+response.data.data.Statistic_Data.fm_visit_times+"";
        this.numList.num[2]=num3.replace(/(.)(?=[^$])/g,"$1,").split(",");
        this.numList.time=response.data.data.Statistic_Data.count_date;
        this.companyNews=response.data.data.Company_News;
      }, (response) => {});
    },
  },
    created: function () {
      this.getImg();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import url("../assets/swiper.min.css");
  .gallery-top{
    height:386px;
    width:100%;
    margin-top: 114px;
  }
  .gallery-thumbs .swiper-slide{
    width:30%;
    height:6rem;
    opacity:0.3;
  }
  .swiper-slide{
    background-size: 100%;
    -webkit-background-size: 100%;
  }
  .huiSe1{background: url("../../site/ttqappbg.jpg") no-repeat center;background-size: auto 100%}
  .hs-box{text-align: center;padding: 70px 0}
  .hs-box-s{text-align: center;background: #f7f8fa;padding: 80px 0}
  .introduction{color: #333;font-size: 36px;letter-spacing: 13px}
  .introduction label{color: #999;font-size: 20px;position: relative;top:-20px;left:-5px;letter-spacing: 0}
  .hsBoxLi3{background: url("../../site/2-11.png") no-repeat center;height: 148px;margin: 40px 0 40px 0}
  .hsBoxLi4{background: url("../../site/2-12.png") no-repeat center;height: 148px;margin: 100px 0 40px 0}
  .hsBoxLi5{background: url("../../site/2-13.png") no-repeat center;height: 148px;margin: 100px 0 40px 0}
  .hsBoxLi6{background: url("../../site/2-14.png") no-repeat center;height: 148px;margin: 100px 0 40px 0}
  .hsBoxLi7{background: url("../../site/2-15.png") no-repeat center;height: 148px;margin: 100px 0 40px 0}
  .hsBoxLi8{background: url("../../site/2-16.png") no-repeat center;height: 148px;margin: 100px 0 40px 0}
  .hsBoxLiTitle{color: #333;font-size: 34px;margin-bottom: 20px}
  .hsBoxLiText{color: #999;font-size: 26px;line-height: 40px;-webkit-text-size-adjust: none;}
  .numTitle{font-size: 30px;color: #333;margin-top: 60px}
  .numNum{color: #333;font-size: 24px;margin: 30px 0}
  .numNum label{font-size:40px;display: inline-block;background-image: url("../../site/3-bg.png");background-size:100%;width: 80px;height:80px;color: #fff;line-height: 80px}
  .numTime{font-size: 16px;color: #999}
  .diTu{background: url('../../site/4-1.png') no-repeat center;width: 100%;background-size: 100%;height: 580px;color: #333;margin-bottom: 30px}
  .diTu span{text-align: right;display: inline-block;position: relative;  top: 590px;  left: 210px;}
  .diTu label{font-size: 26px;font-weight: bold}
  .hs-app{color: #fff;font-size: 48px;}
  .hs-appText{color: #fff;font-size: 24px;margin: 40px auto;text-align: left;width: 390px;padding-left: 10px}
  .hs-appTu{background: url("../../site/5-2.png") no-repeat center;height: 550px;width: 100%;}
  .box6-14{height: 86px;width: 318px;display: inline-block;background: url("../../site/xzbuts.png") no-repeat;margin-top: 50px;color: #fff;font-size: 2.5em;padding-top: 20px}
  .hsDynamicLi{position: relative;height: 170px;margin-bottom: 40px}
  .hsDynamicTu{width: 200px;height: 190px;border-radius: 10px;margin-right: 10px}
  .hsDynamicTop{display: inline-block;height: 80px;overflow: hidden; color: #333;font-size: 28px;position: absolute;top:0}
  .hsDynamicBottom{color: #999;font-size: 20px;line-height: 30px;position: absolute;bottom: 0;word-break:break-all;display:-webkit-box; -webkit-line-clamp:3; -webkit-box-orient:vertical; overflow:hidden;}
  .hsDynamicLiText{width: 470px;display: inline-block;height: 170px;vertical-align: top;text-align: left;position: relative}
  .box61HsTu{width: 59%;height: 110px;display: inline-block;}
  .box62HsTu{width: 39%;height: 110px;display: inline-block;}
  .hs-logo2{background: url("../../site/logo.png") no-repeat center;height: 98px;margin-bottom: 35px;background-size: auto 100%}
  .hs-end{font-size: 20px;color: #999;line-height: 20px;-webkit-text-size-adjust: none}
  .box1-uls{margin-top: 20px;text-align: left}
  .box1-uls li{line-height: 24px;text-align: center;vertical-align: top;margin: 30px 0 100px 0}
  .ul-div{width: 450px;font-size: 26px;  margin: 0 auto;  overflow: hidden;  border: 1px solid #e9ebeb;box-shadow: 0 0 5px #e9ebeb;  border-radius: 5px;height: 450px}
  .ul-p{height: 200px;line-height: 265px;width: 450px;margin: 0 auto;font-size: 18px}
  .title1{font-size:34px;margin: 30px 0;font-width:fold;}
  .content1{font-size:24px;line-height: 40px}
  .numNum .numListTu0{font-size:40px;display: inline-block;background-image: url("../../site/3-bg.png");background-size: 100%; width: 80px;height: 80px;color: #04b7a0;line-height: 80px}
  .numNum .numListTu1{font-size:40px;display: inline-block;background-image: url("../../site/31-bg.png");background-size: 100%;width: 80px;height:80px;color: #f36fa7;line-height: 80px}
  .numNum .numListTu2{font-size:40px;display: inline-block;background-image: url("../../site/32-bg.png");background-size: 100%;width: 80px;height: 80px;color: #f7ca51;line-height: 80px}
</style>



// WEBPACK FOOTER //
// Hello.vue?487ef3c7